import { HIDE_COMPONENT_CAP } from './hide-component.capability';
import { RESTYLE_CAP } from './restyle.capability';
import { SHOW_COMPONENT_CAP } from './show-component.capability';
import { UPDATE_QUERY_PARAM_CAP } from './update-query-param.capability';
import { GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP } from './global-keyboard-shortcut-listener.capability';
import { NAVIGATE_TO_CAP } from './navigate-to.capability';
import { CHANGE_SEARCH_FILTER_CAP } from './change-search-filter.capability';
import { CHANGE_SEARCH_CAP } from './change-search.capability';
import { ADD_TO_BOOKMARKS_CAP } from './add-to-bookmarks.capability';
import { UPSERT_GLOBAL_STYLES_CAP } from './upsert-global-styles.capability';
import { DELETE_GLOBAL_STYLES_CAP } from './delete-global-styles.capability';
import { UPDATE_BELL_ICON_COUNT_CAP } from './update-bell-icon-count.capability';
import { UPDATE_CALL_ICON_STATUS_CAP } from './update-call-icon-status.capability';
import { UPDATE_THIRD_PARTY_CALL_STATUS_CAP } from './update-third-party-call-status.capability';
import { ALERT_MESSAGE_CAP } from './alert-message.capability';
import { RELOAD_PAGE_CAP } from './reload-page.capability';
import { TOGGLE_NOTIFICATION_SIDEBAR_CAP } from './toggle-notifications-sidebar.capability';
import { TOGGLE_CSAT_SURVEY_CAP } from './toggle-csat-survey.capability';
import { SHOW_DEMO_EXIT_CONFIRMATION_CAP } from './show-demo-exit-confirmation.capability';
import { __NOOP_MOCK_CAP } from './internal/noop.capability';
import { GLOBAL_HOME_WIDGET_TRACKING_CAP } from './global-home/global-home-widget-tracking.capability';
import { TRACK_WIDGET_INTERACTION_CAP } from './global-home/track-widget-interaction.capability';
import { TOGGLE_FULLSCREEN_MODE_CAP } from './toggle-fullscreen-mode.capability';
export const capabilities = {
  SHOW_COMPONENT_CAP,
  HIDE_COMPONENT_CAP,
  RESTYLE_CAP,
  UPDATE_QUERY_PARAM_CAP,
  GLOBAL_KEYBOARD_SHORTCUT_HANDLER_CAP,
  NAVIGATE_TO_CAP,
  CHANGE_SEARCH_FILTER_CAP,
  CHANGE_SEARCH_CAP,
  ADD_TO_BOOKMARKS_CAP,
  UPSERT_GLOBAL_STYLES_CAP,
  DELETE_GLOBAL_STYLES_CAP,
  UPDATE_BELL_ICON_COUNT_CAP,
  UPDATE_CALL_ICON_STATUS_CAP,
  UPDATE_THIRD_PARTY_CALL_STATUS_CAP,
  ALERT_MESSAGE_CAP,
  RELOAD_PAGE_CAP,
  TOGGLE_NOTIFICATION_SIDEBAR_CAP,
  __NOOP_MOCK_CAP,
  TOGGLE_CSAT_SURVEY_CAP,
  SHOW_DEMO_EXIT_CONFIRMATION_CAP,
  GLOBAL_HOME_WIDGET_TRACKING_CAP,
  TRACK_WIDGET_INTERACTION_CAP,
  TOGGLE_FULLSCREEN_MODE_CAP
};